import { HttpClient, HttpErrorResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "../../../../environments/environment";
import { UserModel } from "../../models/user/user.model";
import { Observable, retry, throwError, timer } from "rxjs";

// 0 = network failure, 504 = synthesized by the service worker on network failure,
// 401 = backend JWKS refresh timeout
const TRANSIENT_STATUSES = new Set([0, 401, 500, 502, 503, 504]);
const MAX_RETRIES = 3;


@Injectable({
	providedIn: 'root'
})

export class UserService {
	endpoint: string = environment.backend_url + '/api/v1/user';

	constructor(private readonly http: HttpClient) {
		this.http = http;
	}

	checkAccess(userRequest: UserModel): Observable<boolean> {
		const subRoute = '/checkAccess';
		return this.http.post<boolean>(this.endpoint + subRoute, userRequest).pipe(
			retry({
				count: MAX_RETRIES,
				delay: (error, retryCount) => UserService.isTransientError(error)
					? timer(1000 * 2 ** (retryCount - 1))
					: throwError(() => error)
			})
		);
	}

	static isTransientError(error: unknown): boolean {
		return error instanceof HttpErrorResponse && TRANSIENT_STATUSES.has(error.status);
	}

	checkRol(userRequest: UserModel): Observable<boolean> {
		const subRoute = '/checkRol';
		return this.http.post<boolean>(this.endpoint + subRoute, userRequest);
	}
}
